import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=22f7beba&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=ts&"
export * from "./Checkout.vue?vue&type=script&lang=ts&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=22f7beba&scoped=true&lang=scss&"
import style1 from "./Checkout.vue?vue&type=style&index=1&id=22f7beba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7beba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDivider,VSnackbar,VTextField})
